import React, { Children, cloneElement } from 'react';
import { tokens } from '@everfi/design-system';
import { Layout } from '../../../core/components/Layout/component.js';

var LegacyCardChildren = function LegacyCardChildren(_ref) {
  var cardProps = _ref.cardProps,
      cardEffects = _ref.cardEffects;
  var children = cardProps.children,
      parentLabel = cardProps.parentLabel,
      mediaSize = cardProps.mediaSize;
  var showChildren = cardEffects.showChildren;
  if (!showChildren || !children) return null;
  return /*#__PURE__*/React.createElement(Layout, null, Children.map(children, function (child) {
    return child ? /*#__PURE__*/React.createElement(Layout, {
      margin: tokens.SpacingBaseMd
    }, /*#__PURE__*/cloneElement(child, {
      isChildCard: true,
      parentMediaSize: parentLabel ? mediaSize : null
    })) : /*#__PURE__*/React.createElement(React.Fragment, null);
  }));
};

LegacyCardChildren.displayName = "LegacyCardChildren";
export { LegacyCardChildren };